module.exports = __webpack_public_path__ + "img/image-04.d63ad508.jpg";